<template>
  <el-dialog custom-class="max-dialog1256" title="内部邮件" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false"
  >
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item label="交流主题" :label-width="formLabelWidth" prop="extitle">
            <el-input v-model="form.extitle" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="needdate">
        <el-col :span="20">
          <el-form-item label="参与人员" :label-width="formLabelWidth" prop="names">
            <el-input v-model="form.names" auto-complete="off" :required="true" readonly="true" :rows="2" type="textarea"></el-input>
          </el-form-item>
          <div hidden>
            <el-form-item label="参与人员uid" :label-width="formLabelWidth" prop="ids">
              <el-input v-model="form.ids" auto-complete="off" :required="true"></el-input>
            </el-form-item>
            <el-form-item label="参与人员部门" :label-width="formLabelWidth" prop="deptnames">
            <el-input v-model="form.deptnames" auto-complete="off" :required="true"></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="4"> <el-button type="primary" icon="el-icon-user" circle @click="showSelectPage"></el-button></el-col>
      </el-row>
      <el-row :gutter="25">
        <el-col :span="12">
          <el-form-item label="附件" :label-width="formLabelWidth" prop="attguid">
            <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="!CanEdit"
                          @afterBind="afterBind"
                          groupType="exchange" :limit="10"></CommonUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="25">
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth" prop="feedcontent">
            <QuillEditor ref="refdiscripExchangeEdit" toolbarid="exchangeedittoolbar" :content="form.feedcontent"
                         @on-content-change="changeDiscrip"></QuillEditor>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
      <AppendUser ref="AppendUser" @selectUsers="selectUsers"></AppendUser>
    </div>
  </el-dialog>
</template>
<script>
  import {getUsersTree} from '@/api/set/post';
  import {saveData} from '@/api/oa/exchange';
  import {attUUID} from '@/api/attachment';
  import QuillEditor from '../../common/QuillEditor'
  import AppendUser from './AppendUser'

  export default {
    name: "ExchangeEdit",
    data() {
      return {
        CanEdit: true,
        isDisable: false,
        dialogFormVisible: false,
        needdate: true,
        userdata:[],
        form: {  //表单数据
          receiveuname: '',
          ids: '',
          names: '',
          deptnames:'',
          attguid: '',
          extitle: '',
          feedcontent: '',
          isdel: 0,
          hasattach: 0
        },

        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          extitle: [
            {required: true, message: '请输入主题', trigger: 'blur'},
          ],
          names: [
            {required: true, message: '请选择人员', trigger: 'blur'},
          ],
          feedcontent: [
            {required: true, message: '请输入内容', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      showSelectPage(){
        this.$refs.AppendUser.showAdd(this.userdata);
      },
      afterBind(fileList) {
          this.form.hasattach = fileList.length;
      },
      show() {
        this.form.attguid = attUUID();
        this.dialogFormVisible = true;
      },
      changeDiscrip(val) {
        this.form.feedcontent = val;
      },
      selectUsers(arr,userdata) {
        this.form.ids = arr.ids;
        this.form.names =  arr.names;
        this.form.deptnames =  arr.deptnames;
        this.userdata=userdata;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            saveData(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                });
                //刷新列表
                this.$emit('bindExchangeList', '7');
                this.dialogFormVisible = false;
              } else {
                this.$message.error(response.data.msg);
              }
              this.isDisable = false;
            });
          }
        })
      },
      initForm() {
        this.userdata=[];
        this.form.receiveuname = '';
        this.form.ids = '';
        this.form.names = '';
        this.form.extitle = '';
        this.form.feedcontent = '';
        this.form.isdel = 0;
        this.form.deptnames = '';
        this.form.hasattach = 0
      }
    },
    mounted() {
    },
    components: {
      QuillEditor,
      AppendUser
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oa/exchange/ExchangeEdit.vue